import { GridCol, Icon, ICONS } from '@bob/library'
import { Asset, AssetProps } from '@websrc/App/Components/Asset/Asset'
import { mapLink } from '@websrc/DataMappers/mapLink'
import React from 'react'

import * as SC from './ProductResourceHeader.style'

export interface ProductResourceHeaderProps {
  asset?: AssetProps
  caption?: string | null
  headline?: string | null
  link: ReturnType<typeof mapLink>
}

export function ProductResourceHeader({
  asset,
  caption,
  headline,
  link,
}: ProductResourceHeaderProps) {
  return (
    <SC.StyledHeaderGridRow>
      <GridCol tablet={6}>
        <Asset
          {...asset}
          sizes={'(min-width: 1024px) 600px'}
          srcSetWidths={[320, 400, 600, 800, 1200]}
        />
      </GridCol>
      <GridCol tablet={6}>
        <SC.StyledCaption>{caption}</SC.StyledCaption>
        <SC.StyledHeader>{headline}</SC.StyledHeader>

        {link.cta_text && (
          <SC.StyledLink ctaType={'tertiary'} link={link}>
            <Icon icon={ICONS.ARROW_RIGHT} size={16} />
            <span>{link.cta_text}</span>
          </SC.StyledLink>
        )}
      </GridCol>
    </SC.StyledHeaderGridRow>
  )
}
